import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { useStaff, Loading } from "../StaffAuth";
import { api, supabase } from "../client";
import { Field } from "../ui";

export default function ResetPassword() {
  const { staff, loading, markReset, signOut } = useStaff();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (loading) return <Loading />;
  if (!staff) {
    return (
      <div className="staff-root flex min-h-screen items-center justify-center p-6 text-center" data-testid="reset-no-session">
        <p className="text-sm text-[var(--s-dim)]">Sign in with your temporary password first. <Link to="/staff/login" className="text-[var(--s-accent)] underline">Go to sign in</Link></p>
      </div>
    );
  }
  if (!staff.must_reset_password) return <Navigate to="/staff/overview" replace />;
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 10) return setErr("Use at least 10 characters.");
    if (pw !== pw2) return setErr("Passwords do not match.");
    setBusy(true); setErr("");
    try {
      await api("/staff/reset-password", { method: "POST", body: { password: pw } });
      await supabase.auth.signInWithPassword({ email: staff.email, password: pw });
      markReset();
      nav("/staff/overview", { replace: true });
    } catch (e2) { setErr(e2.message); } finally { setBusy(false); }
  };
  return (
    <div className="staff-root flex min-h-screen items-center justify-center px-6 py-16">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6 s-rise" data-testid="staff-reset-form">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--s-accent)] text-black"><KeyRound size={18} /></div>
        <div>
          <h2 className="s-display text-2xl">Set your password</h2>
          <p className="mt-1 text-sm text-[var(--s-dim)]">Your account uses a temporary password. Choose a new one to unlock the workspace.</p>
        </div>
        <Field label="New password"><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="s-input" autoComplete="new-password" data-testid="staff-reset-password" /></Field>
        <Field label="Confirm password"><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="s-input" autoComplete="new-password" data-testid="staff-reset-password-confirm" /></Field>
        {err && <p role="alert" className="text-sm text-red-300" data-testid="staff-reset-error">{err}</p>}
        <Button type="submit" disabled={busy} className="s-btn w-full" data-testid="staff-reset-submit">{busy ? "Saving…" : "Update password"}</Button>
        <button type="button" onClick={signOut} className="w-full text-xs text-[var(--s-dim)] hover:text-[var(--s-text)]" data-testid="staff-reset-signout">Sign out</button>
      </form>
    </div>
  );
}
